import {
  createBrowserRouter,
  RouterProvider as ReactRouterProvider,
  Navigate,
} from "react-router-dom";
import MainLayout from "@/components/MainLayout";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import routes from "@/routes/routes";

import Procedures from "@/pages/Procedures";
import Emails from "@/pages/Emails";
import LiasseFiscale from "@/pages/LiasseFiscale";
import TransactionsBancaires from "@/pages/TransactionsBancaires";
import RiskInfo from "@/pages/RiskInfo";
import FinancingSolutions from "@/pages/FinancingSolutions";
import Companies from "@/pages/Companies";
import CompanyDocuments from "@/pages/company/company_documents";
import CompanyAnalysis from "@/pages/CompanyAnalysis";
import Settings from "@/pages/Settings";
import EmailConfirmation from "@/pages/EmailConfirmation";
import PasswordResetRequest from "@/pages/PasswordResetRequest";
import PasswordResetConfirm from "@/pages/PasswordResetConfirm";
import Invitation from "@/pages/Invitation";
import CreateAccount from "@/pages/CreateAccount";
import ErrorBoundary from "@/pages/ErrorBoundary";
import Account from "@/pages/Account";

const authRoutes = [
  { path: routes.account, element: <Account /> },
  { path: routes.confirmEmail + "/:key", element: <EmailConfirmation /> },
  { path: routes.forgotPassword, element: <PasswordResetRequest /> },
  { path: routes.resetPassword + "/:key", element: <PasswordResetConfirm /> },
  { path: routes.invitation, element: <Invitation /> },

];

const mainRoutes = [
  { index: true, element: <Navigate to={routes.societes.root} replace /> },
  { path: routes.createAccount, element: <CreateAccount /> },
  { path: routes.settings, element: <Settings /> },
  { path: routes.societes.root, element: <Companies /> },
  { path: routes.procedures, element: <Procedures /> },
  { path: routes.emails, element: <Emails /> },
  { path: routes.liasse, element: <LiasseFiscale /> },
  { path: routes.transactions, element: <TransactionsBancaires /> },
  { path: routes.tresorerie, element: <RiskInfo /> },
  { path: routes.financement, element: <FinancingSolutions /> },
  { path: routes.company.documents, element: <CompanyDocuments /> },
  { path: routes.etude, element: <CompanyAnalysis /> },
];

const appRouter = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      ...authRoutes,
      {
        element: (
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        ),
        children: mainRoutes,
      },
    ],
  },
]);

export default function RouterProvider() {
  return <ReactRouterProvider router={appRouter} />;
}
